// Cliente axios + endpoints del modulo Pacientes.
// Vive dentro de containers/pages (no en redux/) porque este modulo no usa
// Redux para el CRUD: cada pagina llama directo a estas funciones. El
// interceptor de sesion global (redux/axiosSetup.js) ya esta parcheado
// sobre axios.create, asi que esta instancia hereda el manejo de token
// vencido / refresh sin configuracion adicional.
import axios from "axios";
import { PATH } from "../../redux/utils";

export const apiPacientes = axios.create({ baseURL: PATH });

export const authHeaderPacientes = () => {
  const token = localStorage.getItem("token");
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

const H = () => ({ headers: authHeaderPacientes() });

// ---------------------------------------------------------------------
// Pacientes (CRUD principal)
// ---------------------------------------------------------------------
// filtros: { search, telefono, correo, aseguradoras: [ids], orden }
export const getPacientes = (filtros = {}) => {
  const { search, telefono, correo, aseguradoras, orden } = filtros;
  const params = {};
  if (search) params.search = search;
  if (telefono) params.telefono = telefono;
  if (correo) params.correo = correo;
  if (aseguradoras?.length) params.aseguradoras = aseguradoras.join(",");
  if (orden) params.orden = orden;
  return apiPacientes.get("/pacientes", { ...H(), params });
};

export const getPaciente = (id) => apiPacientes.get(`/pacientes/${id}`, H());

export const crearPaciente = (payload) => apiPacientes.post("/pacientes", payload, H());

export const editarPaciente = (id, payload) => apiPacientes.put(`/pacientes/${id}`, payload, H());

export const eliminarPaciente = (id) => apiPacientes.delete(`/pacientes/${id}`, H());

export const subirFotoPaciente = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return apiPacientes.post(`/pacientes/${id}/foto`, fd, H());
};

// ---------------------------------------------------------------------
// Catalogos de solo lectura
// ---------------------------------------------------------------------
export const getTiposEstudio = () => apiPacientes.get("/tipos-estudio", H());
export const getAseguradorasCatalogo = () => apiPacientes.get("/aseguradoras/catalogo", H());

// ---------------------------------------------------------------------
// Antecedentes (siempre inserta uno nuevo; "vigente" = el mas reciente)
// ---------------------------------------------------------------------
export const getAntecedentes = (idPaciente) => apiPacientes.get(`/pacientes/${idPaciente}/antecedentes`, H());
export const guardarAntecedentes = (idPaciente, payload) =>
  apiPacientes.post(`/pacientes/${idPaciente}/antecedentes`, payload, H());

// ---------------------------------------------------------------------
// Aseguradoras del paciente
// ---------------------------------------------------------------------
export const getPacienteAseguradoras = (idPaciente) => apiPacientes.get(`/pacientes/${idPaciente}/aseguradoras`, H());
export const crearPacienteAseguradora = (idPaciente, payload) =>
  apiPacientes.post(`/pacientes/${idPaciente}/aseguradoras`, payload, H());
export const editarPacienteAseguradora = (id, payload) =>
  apiPacientes.put(`/paciente-aseguradoras/${id}`, payload, H());
export const eliminarPacienteAseguradora = (id) => apiPacientes.delete(`/paciente-aseguradoras/${id}`, H());

// ---------------------------------------------------------------------
// Responsables
// ---------------------------------------------------------------------
export const getPacienteResponsables = (idPaciente) => apiPacientes.get(`/pacientes/${idPaciente}/responsables`, H());
export const crearPacienteResponsable = (idPaciente, payload) =>
  apiPacientes.post(`/pacientes/${idPaciente}/responsables`, payload, H());
export const editarPacienteResponsable = (id, payload) =>
  apiPacientes.put(`/paciente-responsables/${id}`, payload, H());
export const eliminarPacienteResponsable = (id) => apiPacientes.delete(`/paciente-responsables/${id}`, H());

// ---------------------------------------------------------------------
// Estudios diagnosticos
// ---------------------------------------------------------------------
export const getPacienteEstudios = (idPaciente) => apiPacientes.get(`/pacientes/${idPaciente}/estudios`, H());
export const crearPacienteEstudio = (idPaciente, payload) =>
  apiPacientes.post(`/pacientes/${idPaciente}/estudios`, payload, H());
export const editarPacienteEstudio = (id, payload) =>
  apiPacientes.put(`/estudios-diagnosticos/${id}`, payload, H());
export const eliminarPacienteEstudio = (id) => apiPacientes.delete(`/estudios-diagnosticos/${id}`, H());

// ---------------------------------------------------------------------
// Graduaciones de lentes
// ---------------------------------------------------------------------
export const getPacienteGraduaciones = (idPaciente) => apiPacientes.get(`/pacientes/${idPaciente}/graduaciones`, H());
export const crearPacienteGraduacion = (idPaciente, payload) =>
  apiPacientes.post(`/pacientes/${idPaciente}/graduaciones`, payload, H());
export const editarPacienteGraduacion = (id, payload) =>
  apiPacientes.put(`/graduaciones-lentes/${id}`, payload, H());
export const eliminarPacienteGraduacion = (id) => apiPacientes.delete(`/graduaciones-lentes/${id}`, H());

// ---------------------------------------------------------------------
// Recetas
// ---------------------------------------------------------------------
export const getPacienteRecetas = (idPaciente) => apiPacientes.get(`/pacientes/${idPaciente}/recetas`, H());
export const crearPacienteReceta = (idPaciente, payload) =>
  apiPacientes.post(`/pacientes/${idPaciente}/recetas`, payload, H());
export const editarPacienteReceta = (id, payload) => apiPacientes.put(`/recetas/${id}`, payload, H());
export const eliminarPacienteReceta = (id) => apiPacientes.delete(`/recetas/${id}`, H());

// ---------------------------------------------------------------------
// Planes de vigilancia
// ---------------------------------------------------------------------
export const getPacientePlanesVigilancia = (idPaciente) =>
  apiPacientes.get(`/pacientes/${idPaciente}/planes-vigilancia`, H());
export const crearPacientePlanVigilancia = (idPaciente, payload) =>
  apiPacientes.post(`/pacientes/${idPaciente}/planes-vigilancia`, payload, H());
export const editarPacientePlanVigilancia = (id, payload) =>
  apiPacientes.put(`/planes-vigilancia/${id}`, payload, H());
export const eliminarPacientePlanVigilancia = (id) => apiPacientes.delete(`/planes-vigilancia/${id}`, H());

// ---------------------------------------------------------------------
// Referencias
// ---------------------------------------------------------------------
export const getPacienteReferencias = (idPaciente) => apiPacientes.get(`/pacientes/${idPaciente}/referencias`, H());
export const crearPacienteReferencia = (idPaciente, payload) =>
  apiPacientes.post(`/pacientes/${idPaciente}/referencias`, payload, H());
export const editarPacienteReferencia = (id, payload) =>
  apiPacientes.put(`/referencias/${id}`, payload, H());
export const eliminarPacienteReferencia = (id) => apiPacientes.delete(`/referencias/${id}`, H());

// ---------------------------------------------------------------------
// Actividad (audit_log)
// ---------------------------------------------------------------------
export const getPacienteActividad = (idPaciente) => apiPacientes.get(`/pacientes/${idPaciente}/actividad`, H());
